import styles from 'css/src/components/public-pages/ContentfulImageOrVideo.module.scss';

import React from 'react';

import VideoPlayerWithButton from 'js/src/components/public-pages/common-sections/VideoPlayerWithButton';
import type { ImmutableMap } from 'js/src/libs/consts';
import ContentfulTools from 'js/src/libs/contentful-tools';
import type { ContentfulImageOrVideoData } from 'js/src/libs/contentful-utils';

const ContentfulImageOrVideo = React.memo(function ContentfulImageOrVideo({
    data,
    posterForVideo,
    urlWidth,
    style,
    className = '',
    lazyLoad = true,
}: {
    data: ImmutableMap<ContentfulImageOrVideoData>;
    posterForVideo?: ImmutableMap<ContentfulImageOrVideoData>;
    urlWidth: number;
    style?: Record<string, string | number>;
    className?: string;
    lazyLoad: boolean;
}) {
    if (!data) {
        return null;
    }

    if (data.get('file').get('contentType').startsWith('video')) {
        let imgSrc;
        if (posterForVideo) {
            imgSrc = ContentfulTools.getUrl(posterForVideo.get('file').get('url'), {
                width: urlWidth,
                format: 'webp',
                quality: 80,
            });
        }
        return (
            <VideoPlayerWithButton
                videoSrc={'https:' + data.get('file').get('url')}
                imgSrc={imgSrc}
                modalPreviewOnClick={true}
                preload={lazyLoad ? 'none' : 'auto'}
            />
        );
    } else {
        return (
            <img
                className={`${styles['contentful-image']} ${className}`}
                style={style}
                src={ContentfulTools.getUrl(data.get('file').get('url'), {
                    width: urlWidth,
                    format: 'webp',
                    quality: 80,
                })}
                alt={data.get('description')}
                loading={lazyLoad ? 'lazy' : 'eager'}
                decoding={lazyLoad ? 'async' : 'sync'}
            />
        );
    }
});

export default ContentfulImageOrVideo;
